document.addEventListener('DOMContentLoaded', () => {


    function slideDown(element, duration = 750) {
        element.style.removeProperty('display');

        let display = window.getComputedStyle(element).display;
        if (display === 'none') display = 'block';

        element.style.display = display;
        element.style.overflow = 'hidden';
        element.style.height = '0';
        element.style.paddingTop = '0';
        element.style.paddingBottom = '0';
        element.style.marginTop = '0';
        element.style.marginBottom = '0';

        const height = element.scrollHeight;

        element.style.transition = `height ${duration}ms ease`;

        requestAnimationFrame(() => {
            element.style.height = height + 'px';
        });

        setTimeout(() => {
            element.style.removeProperty('height');
            element.style.removeProperty('overflow');
            element.style.removeProperty('transition');
        }, duration);
    }

    document.addEventListener('click', function (e) {
        if (e.target.matches('.more-products-button a')) {
            e.preventDefault();

            const button = e.target;
            const wrapper = button.closest('.more-products-button')?.parentElement?.querySelector('.more-products-list--hidden');

            if (wrapper) {
                slideDown(wrapper, 750);
                wrapper.classList.remove('more-products-list--hidden');
                button.remove();
            }
        }
    });

});